/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetAodRunsOneAugmentedQueryResponse, AuditReportsGetAodRunsOneAugmentedPathParams, AuditReportsGetAodRunsOneAugmentedQueryParams, AuditReportsGetAodRunsOneAugmented401, AuditReportsGetAodRunsOneAugmented403 } from "../models/AuditReportsGetAodRunsOneAugmented";

export function getAuditReportsGetAodRunsOneAugmentedUrl(id: AuditReportsGetAodRunsOneAugmentedPathParams["id"]) {
  const res = { method: 'GET', url: `/audit-reports/v1/aod-runs/${id}` as const }
  return res
}

/**
 * @summary Retrieve a single AodRun
 * {@link /audit-reports/v1/aod-runs/:id}
 */
export async function auditReportsGetAodRunsOneAugmented(id: AuditReportsGetAodRunsOneAugmentedPathParams["id"], params?: AuditReportsGetAodRunsOneAugmentedQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsGetAodRunsOneAugmentedQueryResponse, ResponseErrorConfig<AuditReportsGetAodRunsOneAugmented401 | AuditReportsGetAodRunsOneAugmented403>, unknown>({ method : "GET", url : getAuditReportsGetAodRunsOneAugmentedUrl(id).url.toString(), params, ... requestConfig })
  return res.data
}